<template>
    <div v-if="isMounted">
        <div class="left card">
            <div class="card-body">
                优惠待定
            </div>
        </div>
        <div class="right card">
            <div class="card-body">
                <el-form size="mini">
                    <el-form-item label="订单总价">
                        {{$parentInfo.studentCart.sumPay|currency('￥',2)}}
                        <el-dialog
                                width="20%"
                                title="分期付款"
                                :visible.sync="$parentInfo.studentCart.innerVisible"
                                append-to-body>
                            <el-form>
                                <el-form-item label="结算价格">
                                    {{remainPay|currency('￥',2)}}
                                </el-form-item>
                                <el-form-item label="首付">
                                    <el-input-number v-model="$parentInfo.studentCart.dialog_Installment.proportion"
                                                     :max="$parentInfo.studentCart.sumPay"
                                                     :min="0"
                                                     placeholder="请输入首付金额"></el-input-number>
                                </el-form-item>
                            </el-form>
                            <div class="text-right">
                                <el-button type="primary" size="small" @click="handleChangeInstallment()"
                                           :loading="$parentInfo.studentCart.dialog_Installment.button_loading">确定
                                </el-button>
                            </div>
                        </el-dialog>
                    </el-form-item>
                    <el-form-item label="家长">
                        <el-select v-model="$parentInfo.studentCart.invoiceForm.parent_id"
                                   placeholder="请选择家长">
                            <el-option
                                    v-for="item in $parentInfo.student.parents"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id">
                                <span style="float: left">{{ item.name }}</span>
                                <span style="float: right; color: #8492a6; font-size: 13px">{{item.parent_identity }}</span>
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-row :gutter="20">
                        <el-col :span="8"
                                v-for="item in $parentInfo.studentCart.invoiceForm.payment_types"
                                :key="item.id">
                            <el-form-item :label="item.name" label-position="top">
                                <el-input :disabled="item.id===9"
                                          v-model="$parentInfo.studentCart.invoiceForm.payment_types[item.id].balance"
                                          :placeholder="'0'" v-if="item.id!==5"></el-input>
                                <el-input disabled
                                          v-else
                                          v-model="$parentInfo.studentCart.invoiceForm.payment_types[item.id].balance"
                                          :placeholder="'0'"></el-input>
                                <!--                                @click.native="handleDiscountType(item.id)"-->
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <el-form-item label="结算差价">
                        {{remainPay|currency('￥',2)}}
                    </el-form-item>
                </el-form>
                <div style="text-align: right">
                    <el-button type="primary" @click="handleCheckOut()"
                               :loading="$parentInfo.studentCart.button_loading">确 认 支 付
                    </el-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Dialog_SettleAccounts",
        data() {
            return {
                isMounted: false,
                personalCashDiscount: 0,
                selfDiscounts_id: '',
                selfCashDiscount: 0,
            };
        },
        computed: {
            remainPay: function () {
                var sum = 0;
                for (const key in this.$parentInfo.studentCart.invoiceForm.payment_types) {
                    if (this.$parentInfo.studentCart.invoiceForm.payment_types[key].balance) {
                        sum += parseFloat(this.$parentInfo.studentCart.invoiceForm.payment_types[key].balance);
                    }
                }
                return this.$parentInfo.studentCart.sumPay - sum;
            },
        },
        mounted() {
            this.$parentInfo = this.$root.$children[0].$refs['dashboard'].$refs[this.$route.path];
            this.isMounted = true;
        },
        methods: {
            handleCheckOut() {
                this.$confirm('确认结算?', '提示', {
                    StartReturn: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$parentInfo.studentCart.button_loading = true;
                    this.$wApi.send(this.$parentInfo.path, 'settle_anotherAccount', {
                        'payments': this.$parentInfo.studentCart.invoiceForm.payment_types,
                        'choose_cart_classHour_ids': this.$store.state.modal.data.choose_cart_classHour_ids,
                        'choose_cart_shop_ids': this.$store.state.modal.data.choose_cart_shop_ids,
                        'student_id': this.$parentInfo.student_id,
                        'parent_id': this.$parentInfo.studentCart.invoiceForm.parent_id,
                    });
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消'
                    });
                });
            },
        }
    }
</script>

<style scoped>
    .left {
        float: left;
        width: 300px;
    }

    .right {
        margin-left: 310px;
    }
</style>
